var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDockerSwarmIcon = function SvgDockerSwarmIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 34 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.517 4.238h1.597Zm-1.902 0h1.597Zm-1.863 0H7.35Zm-1.863 0h1.56Zm-1.9 0h1.596Zm1.9-1.749h1.56Zm1.863 0H7.35Zm1.863 0h1.597Zm0-1.749h1.597Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.4435,
    d: "M9.517 4.238h1.597m-3.499 0h1.597m-3.46 0H7.35m-3.46 0h1.56m-3.46 0h1.596M3.89 2.49h1.56m.303 0H7.35m.266 0h1.597M7.615.74h1.597"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.209 4.314s-.685-.646-2.092-.418c-.152-1.103-1.33-1.75-1.33-1.75s-1.103 1.332-.305 2.815a2.55 2.55 0 0 1-1.178.266H.847c-.19.722-.19 5.513 5.057 5.513 3.765 0 6.578-1.75 7.91-4.943 1.976.152 2.395-1.483 2.395-1.483ZM26.517 4.238h1.597Zm-1.902 0h1.597Zm-1.863 0h1.597Zm-1.863 0h1.56Zm-1.9 0h1.596Zm1.9-1.749h1.56Zm1.863 0h1.597Zm1.863 0h1.597Zm0-1.749h1.597Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.4435,
    d: "M26.517 4.238h1.597m-3.499 0h1.597m-3.46 0h1.597m-3.46 0h1.56m-3.46 0h1.596m.304-1.749h1.56m.303 0h1.597m.266 0h1.597M24.615.74h1.597"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M33.209 4.314s-.685-.646-2.092-.418c-.152-1.103-1.33-1.75-1.33-1.75s-1.103 1.332-.305 2.815a2.55 2.55 0 0 1-1.178.266H17.847c-.19.722-.19 5.513 5.057 5.513 3.765 0 6.578-1.75 7.91-4.943 1.976.152 2.395-1.483 2.395-1.483ZM18.118 15.522h1.757Zm-2.091 0h1.757Zm-2.05 0h1.757Zm-2.049 0h1.715Zm-2.091 0h1.757Zm2.091-1.924h1.715Zm2.05 0h1.756Zm2.049 0h1.757Zm0-1.924h1.757Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5878500000000002,
    d: "M18.118 15.522h1.757m-3.848 0h1.757m-3.806 0h1.756m-3.806 0h1.715m-3.806 0h1.757m.334-1.924h1.715m.335 0h1.756m.293 0h1.757m-1.757-1.924h1.757"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M25.48 15.606s-.753-.711-2.3-.46c-.168-1.213-1.465-1.924-1.465-1.924s-1.213 1.463-.334 3.095c-.251.125-.67.292-1.297.292H8.582c-.209.795-.209 6.065 5.563 6.065 4.14 0 7.236-1.924 8.7-5.437 2.174.167 2.634-1.631 2.634-1.631Z"
  })));
};
export default SvgDockerSwarmIcon;